import { z } from 'zod';
// =========================================================
// Schemas para la vista de análisis de batches (datos crudos de planta).
//
// Pensado para que desde una muestra de laboratorio que no cumple, el
// laboratorista pueda revisar si la colada tuvo datos alterados: exceso
// de agua, humedad de áridos fuera de rango, aditivo mal dosificado, etc.
//
// Cada fila es UN batch (bachada/camión). Los campos delta_pct son la
// desviación real vs teórica — el dato clave para detectar problemas.
// =========================================================
const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;
export const BatchDetallePlantaSchema = z.object({
    id: z.number().int(),
    record_no: z.number().int(),
    fecha_inicio: z.string(),
    planta_nombre: z.string(),
    cliente_raw: z.string().nullable(),
    recipe_name_raw: z.string().nullable(),
    m3_producidos: z.number(),
    // Receta / diseño por 1 m³ (valores nominales de la receta, constantes
    // por receta — lo que el operador ve como dosificación objetivo).
    arido_a_nombre: z.string().nullable(),
    arido_a_dosis_kg_m3: z.number().nullable(),
    arido_b_nombre: z.string().nullable(),
    arido_b_dosis_kg_m3: z.number().nullable(),
    cemento_dosis_kg_m3: z.number().nullable(),
    agua_dosis_l_m3: z.number().nullable(),
    aditivo1_dosis_l_m3: z.number().nullable(),
    aditivo2_dosis_l_m3: z.number().nullable(),
    aditivo3_dosis_l_m3: z.number().nullable(),
    // Agua — lo más relevante para detectar exceso.
    agua_l: z.number().nullable(),
    agua_l_teor: z.number().nullable(),
    agua_delta_l: z.number().nullable(),
    agua_delta_pct: z.number().nullable(),
    water_dosage_adj: z.boolean().nullable(),
    water_total_adj_l: z.number().nullable(),
    relacion_agua_cemento: z.number().nullable(),
    // Humedad de áridos.
    arido_a_moisture_pct: z.number().nullable(),
    arido_b_moisture_pct: z.number().nullable(),
    // Cemento.
    cemento_kg: z.number().nullable(),
    cemento_kg_teor: z.number().nullable(),
    cemento_delta_pct: z.number().nullable(),
    // Áridos.
    arido_a_kg: z.number().nullable(),
    arido_a_kg_teor: z.number().nullable(),
    arido_a_delta_pct: z.number().nullable(),
    arido_b_kg: z.number().nullable(),
    arido_b_kg_teor: z.number().nullable(),
    arido_b_delta_pct: z.number().nullable(),
    // Aditivos.
    aditivo1_l: z.number().nullable(),
    aditivo1_l_teor: z.number().nullable(),
    aditivo1_delta_pct: z.number().nullable(),
    aditivo2_l: z.number().nullable(),
    aditivo2_l_teor: z.number().nullable(),
    aditivo2_delta_pct: z.number().nullable(),
    aditivo3_l: z.number().nullable(),
    aditivo3_l_teor: z.number().nullable(),
    aditivo3_delta_pct: z.number().nullable(),
    // Ambiente + flags.
    temp_ambiente_inicio: z.number().nullable(),
    temp_ambiente_fin: z.number().nullable(),
    production_rate: z.number().nullable(),
    production_rate_adj: z.boolean().nullable(),
    receta_modificada: z.boolean(),
    tuvo_alarma: z.boolean(),
    cantidad_alarmas: z.number().int(),
    operador: z.string().nullable(),
    // Colada a la que pertenece.
    id_colada: z.number().int().nullable(),
    codigo_interno_colada: z.number().int().nullable(),
});
export const ListarBatchesRequestSchema = z.object({
    id_colada: z.coerce.number().int().positive().optional(),
    id_planta: z.coerce.number().int().positive().optional(),
    desde: z.string().regex(ISO_DATE).optional(),
    hasta: z.string().regex(ISO_DATE).optional(),
    /** Substring sobre cliente_raw / recipe_name_raw / record_no. */
    q: z.string().min(1).max(100).optional(),
    /** Solo batches con alarma o receta modificada (para encontrar anomalías). */
    solo_anomalias: z.coerce.boolean().optional(),
    pagina: z.coerce.number().int().min(1).default(1),
    por_pagina: z.coerce.number().int().min(1).max(500).default(100),
});
export const ListaBatchesResponseSchema = z.object({
    batches: z.array(BatchDetallePlantaSchema),
    total: z.number().int(),
    pagina: z.number().int(),
    por_pagina: z.number().int(),
});
//# sourceMappingURL=batches-detalle.js.map